import {makeStyles} from "@material-ui/core";

export default function SectionCss() {
    return makeStyles(theme => ({
        root: {
            flexGrow: 1,
        },
        paper: {
            padding: theme.spacing(2),
            color: theme.palette.text.secondary,
        },
        container: {
            display: 'flex',
            flexWrap: 'wrap',
        },
        textField: {
            marginLeft: theme.spacing(1),
            marginRight: theme.spacing(1),
            width: '100%',
        },
        boxForm: {
            padding: '30px'
        },
        multilineColor: {
            color: theme.palette.text.primary,
            borderBottomColor: theme.palette.primary.main,
            "&::after": {
                borderBottomColor: theme.palette.primary.main,
            }
        },
        buttonAction: {
            marginTop: 30,
            width: '100%'
        },
        buttonCancelar: {            
            marginRight: '10px',
        },
        cardFile: {
            marginTop: 20,
            marginBottom: 20,
            width: '100%'
        },
        title: {
        }
    }));
}